// extracted by mini-css-extract-plugin
export default {"Folder":"Folder_Folder__t5wvX","card":"Folder_card__3J4Bb","Input34":"Folder_Input34__pn1Zg"};